module.exports = __webpack_public_path__ + "static/assets/cf40829810bd4179a0bb018aec432b0b.gif";